import React from 'react';
import css from './ItemsCheckedListTable.module.css';
import { CheckedItemRow } from './CheckedItemRow/CheckedItemRow';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { ItemEntity } from '@entities/Item/Types';
import {
    BasicTableHeader,
    HeaderCell,
} from '@modules/Steps/Shared/Ui/Headers/BasicTableHeader/BasicTableHeader';
import { CheckedItem } from '@modules/Steps/Shared/Interfaces/CheckedItem';

interface Props {
    itemTypes: ItemTypeEntity[];
}

const headerCells: HeaderCell[] = [
    { title: 'Product', width: '40%' },
    { title: 'Calculated QTY', width: '28%' },
    { title: 'Unit price', width: '22%' },
    { title: 'Total', width: '7%' },
];

export const ItemsCheckedListTable: React.FC<Props> = ({ itemTypes }) => {
    const items: CheckedItem[] = itemTypes.flatMap(itemType =>
        itemType.items
            ? itemType.items.filter(Boolean).map(item => ({
                  item,
                  isLabour: itemType.labor,
              }))
            : []
    );

    return (
        <div className={css.tableContainer}>
            <BasicTableHeader headerCells={headerCells} />
            <div className={css.table}>
                {items.map(item => (
                    <CheckedItemRow item={item} key={item.item.uuid} />
                ))}

                <div className={css.emptyRow}></div>
            </div>
        </div>
    );
};
